import { useEffect, ReactNode } from 'react';
import { Route, RouteProps } from 'wouter';

interface TitledRouteProps extends RouteProps {
  title: string;
  children?: ReactNode;
}

function TitledRoute({ title, children, ...routeProps }: TitledRouteProps) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return <Route {...routeProps}>{children}</Route>;
}

export default TitledRoute;

